import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  children: ReactNode;
}

export function Card({ title, children, className, ...rest }: CardProps) {
  return (
    <div className={['ne-card', className].filter(Boolean).join(' ')} {...rest}>
      {title ? <h2 className="ne-card__title">{title}</h2> : null}
      {children}
    </div>
  );
}
